import React from 'react';
import { useNavigate } from 'react-router-dom';
import useAuthStore from '../../../mobile/store/authStore';

const DashboardLayout = ({ children }) => {
    const navigate = useNavigate();
    const { logout } = useAuthStore();

    const menuItems = [
        { label: '시스템 현황', path: '/admin/dashboard/system' },
        { label: '멤버 관리', path: '/admin/dashboard/members' },
        { label: '알림 발송', path: '/admin/dashboard/notifications' },
        { label: '멤버 신고 관리', path: '/admin/dashboard/reports' },
        { label: '모임 관리', path: '/admin/dashboard/meetings' },
        { label: '제휴매장 관리', path: '/admin/dashboard/partner-places' },
        { label: '제휴매장 신청 관리', path: '/admin/dashboard/partner-place-applications' },
        { label: '이벤트 관리', path: '/admin/dashboard/events' },
        { label: '공지사항 관리', path: '/admin/dashboard/announcements' },
        { label: '결제 관리', path: '/admin/dashboard/payments' },
        { label: '쌀 트랜잭션 관리', path: '/admin/dashboard/rice-transactions' },
        { label: '쌀 지급 및 회수 관리', path: '/admin/dashboard/rice-grant-and-revoke' },
    ];

    const handleLogout = () => {
        alert('로그아웃 되었습니다.');
        logout();
        navigate('/admin');
    };

    return (
        <div className="h-screen flex">
            {/* 사이드바 */}
            <div className="w-30 bg-gray-100 border-r border-gray-200 flex flex-col">
                {/* 사이드바 헤더 - 홈 버튼 */}
                <div className="p-1 border-b border-gray-200">
                    <button 
                        onClick={() => navigate('/admin/dashboard')}
                        className="w-full text-left font-semibold text-sm text-gray-800 hover:text-gray-600"
                    >
                        밥친구 관리 시스템
                    </button>
                </div>

                {/* 메뉴 */}
                <nav className="flex-1 p-2">
                    <ul className="space-y-1">
                        {menuItems.map((item, idx) => (
                            <li key={idx}>
                                <button
                                    onClick={() => navigate(item.path)}
                                    className="w-full text-left text-xs text-gray-700 hover:bg-gray-100"
                                >
                                    {item.label}
                                </button>
                            </li>
                        ))}
                    </ul>
                </nav>

                {/* 로그아웃 버튼 */}
                <div className="border-t border-gray-200">
                    <button 
                        onClick={handleLogout}
                        className="w-full text-left px-2 py-2 text-xs text-red-600 hover:bg-gray-100"
                    >
                        로그아웃
                    </button>
                </div>
            </div>

            {/* 메인 콘텐츠 영역 */}
            <main className="flex-1 overflow-auto">
                {children}
            </main>
        </div>
    );
};

export default DashboardLayout;